export default "__VITE_ASSET__94FOQmi8__"